import { Box } from '@mui/material';
import dayjs from 'dayjs';
import { Form } from 'react-admin';
import DateTimeInputUTC from '../DateTimeInputUTC';
import { useWatch } from 'react-hook-form';
import { useEffect } from 'react';

interface StandaloneDateTimeInputProps {
  label: string;
  value: string | null;
  onChange: (value: string | null) => void;
  sx?: object;
}

const DateTimeInputWithWatch = ({
  source,
  label,
  onChange,
  sx,
}: {
  source: string;
  label: string;
  onChange: (value: string | null) => void;
  sx?: object;
}) => {
  const value = useWatch({ name: source });

  useEffect(() => {
    if (value) {
      onChange(value);
    }
  }, [value, onChange]);

  return (
    <DateTimeInputUTC
      source={source}
      label={label}
      helperText={false}
      sx={sx}
    />
  );
};

export const StandaloneDateTimeInput = ({
  label,
  value,
  onChange,
  sx = { width: 220 },
}: StandaloneDateTimeInputProps) => {
  return (
    <Form
      defaultValues={{ date: value }}
      onSubmit={() => {}}
    >
      <DateTimeInputWithWatch
        source="date"
        label={label}
        onChange={onChange}
        sx={sx}
      />
    </Form>
  );
};

interface StandaloneDateRangeInputProps {
  fromValue: string | null;
  toValue: string | null;
  onFromChange: (value: string | null) => void;
  onToChange: (value: string | null) => void;
  fromLabel?: string;
  toLabel?: string;
  sx?: object;
}

const DateRangeInputs = ({
  onFromChange,
  onToChange,
  fromLabel,
  toLabel,
  sx,
}: {
  onFromChange: (value: string | null) => void;
  onToChange: (value: string | null) => void;
  fromLabel: string;
  toLabel: string;
  sx?: object;
}) => {
  const fromValue = useWatch({ name: 'from' });
  const toValue = useWatch({ name: 'to' });

  useEffect(() => {
    if (fromValue !== undefined) {
      onFromChange(fromValue);
    }
  }, [fromValue, onFromChange]);

  useEffect(() => {
    if (toValue !== undefined) {
      onToChange(toValue);
    }
  }, [toValue, onToChange]);

  return (
    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'flex-end' }}>
      <DateTimeInputUTC
        source="from"
        label={fromLabel}
        helperText={false}
        sx={sx}
      />
      <DateTimeInputUTC
        source="to"
        label={toLabel}
        helperText={false}
        sx={sx}
      />
    </Box>
  );
};

export const StandaloneDateRangeInput = ({
  fromValue,
  toValue,
  onFromChange,
  onToChange,
  fromLabel = 'De',
  toLabel = 'Até',
  sx = { width: 220 },
}: StandaloneDateRangeInputProps) => {
  return (
    <Form
      defaultValues={{ from: fromValue, to: toValue }}
      onSubmit={() => {}}
    >
      <DateRangeInputs
        onFromChange={onFromChange}
        onToChange={onToChange}
        fromLabel={fromLabel}
        toLabel={toLabel}
        sx={sx}
      />
    </Form>
  );
};

export default StandaloneDateTimeInput;
